import { offeringTypeLabels } from '../../../../../../../types/domain/offering/constants';
import { sellSideParticipationSupportedOfferingTypes } from '../../../../../../../types/domain/participation-sets/constants';
import type { ParticipationReportGridColDef, ParticipationReportRecord } from '../../types';

export type Value = ParticipationReportRecord['offeringTypeDisplayName'];

export const setFilterValuesFunc = ({ success, context }) => {
  success(context.offeringTypes.map(type => type.label));
};

export const offeringTypeColDef: ParticipationReportGridColDef<Value> = {
  field: 'offeringTypeDisplayName',
  headerName: 'Offering Type',
  width: 115,
  filter: 'agSetColumnFilter',
  floatingFilter: true,
  filterParams: {
    values: sellSideParticipationSupportedOfferingTypes,
    valueFormatter: ({ value }) => offeringTypeLabels[value] || value,
  },
  server: {
    filterFieldPath: 'offeringType',
    sortFieldPath: 'offeringType.displayName',
  },
};
